export const M300models = ["0136", "016C", "012C", "012D", "012E"];
export const M330models = ["014B", "014C", "014A", "0553"];
export const M331models = ["0533","0535"];
export const M335models = ["0537","0539"];
export const M350models = ["015E", "015F", "0160"];
export const M351models = ["0547"];
export const M352models = ["0548"];

export const MCSVtoModel = (MCSV: string) => {
  if (M300models.includes(MCSV)) {
    return "M301";
  }
  if (M330models.includes(MCSV)) {
    return "M330";
  }
  if (M331models.includes(MCSV)) {
    return "M331";
  }
  if (M335models.includes(MCSV)) {
    return "M335";
  }
  if (M350models.includes(MCSV)) {
    return "M350";
  }
  if (M351models.includes(MCSV)) {
    return "M351";
  }
  if (M352models.includes(MCSV)) {
    return "M352";
  }
};

// M301-G: "0136" #-----Ori, New rename (310)
// M301-GW: 016C #-----Ori, New (364)
// M330-W: 014B #-----Ori, New (331)
// M330-W5: 014C #-----Ori, New (332)
// M350: 015E #-----Ori, New rename (350)
// M360-P: 01F4 #-----Ori, New (500)
// M366-W4: 016E #-----New (366)
// M300: 012C #Not available in the future
// M301: 012D #Not available in the future

// M330: 014A #Not available in the future

// M350-4/6/12/5G: 015F #Not available in the future
// M350-44/66: "0160" #Not available in the future
